//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VMask from '@/components/common/VMask';
export default {
  name: 'widget__commenttipslist',
  components: {
    'v-mask': VMask
  },
  methods: {
    onClose: function onClose() {
      this.$emit('onClose');
    }
  },
  mounted: function mounted() {
    var cssStr = 'overflow-y: hidden; height: 100%;';
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  },
  destroyed: function destroyed() {
    var cssStr = 'overflow-y: auto; height: auto;';
    document.getElementsByTagName('body')[0].style.cssText = cssStr;
    document.body.style.cssText = cssStr;
  }
};